import BasicDateInput from "components/BasicInputs/BasicDateInput";
import { indexData } from "forms";
import useDateState from "helpers/useDateState";

export const DateFilterHeader = ({ type }: { type: string }) => {
    const tabs = indexData(type);

    const { setDates, fromDate, toDate } = useDateState(tabs && tabs[0]);

    return (
        <div className="flex gap-4">
            <div className="w-[240px]">
                <BasicDateInput
                    range
                    placeholder="کل سال مالی"
                    onChange={(x) => setDates(x)}
                    defaultValues={fromDate && toDate ? [fromDate, toDate] : undefined}
                />

            </div>
        </div>
    )
}
export default DateFilterHeader